<div [formGroup]="formGroup()" class="grid grid-cols-1 md:grid-cols-3 gap-3">
  <siat-datepicker-field
    [formGroup]="formGroup()"
    controlName="dateStart"
    [label]="startLabel()"
    [placeholder]="startLabel()"
    class="col-span-2"
    [minDate]="minDateStart"
    [dateFilter]="holidayFilter"
  ></siat-datepicker-field>
  <siat-timepicker-field
    [formGroup]="formGroup()"
    controlName="timeStart"
    label="Ora inizio"
    placeholder="Ora inizio"
    initialScrollTime="07:00"
    [minTime]="minTimeStart"
    [maxTime]="maxTimeStart"
    class="col-span-1"
  ></siat-timepicker-field>
  <siat-datepicker-field
    [formGroup]="formGroup()"
    controlName="dateEnd"
    [label]="endLabel()"
    [placeholder]="endLabel()"
    class="col-span-2"
    [minDate]="minDateEnd"
    [dateFilter]="holidayFilter"
  ></siat-datepicker-field>
  <siat-timepicker-field
    [formGroup]="formGroup()"
    controlName="timeEnd"
    label="Ora fine"
    placeholder="Ora fine"
    initialScrollTime="07:00"
    [minTime]="minTimeEnd"
    [maxTime]="maxTime"
    class="col-span-1"
  ></siat-timepicker-field>
</div>
